exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mde-textarea-wrapper textarea.mde-text:read-only {\n\tbackground-color: #f7f7f7;\n}\n", ""]);

